export enum EntityType {
    CASE = 'CASE',
    CONTRACT = 'CONTRACT',
    EMPLOYEE = 'EMPLOYEE',
    OFFICE = 'OFFICE',
    GENERIC_PARTY = 'GENERIC_PARTY',
    PARTY_COMPANY = 'PARTY_COMPANY',
    PARTY_PERSON = 'PARTY_PERSON',
    PARTY_ADDRESS = 'PARTY_ADDRESS',
    PRACTICE_AREA = 'PRACTICE_AREA',
    TEAM = 'TEAM',
    MATTER = 'MATTER',
    // Backend custom-field EntityType enum uses POSITION (label "JobPosition"); keep wire value in sync.
    JOB_POSITION = 'POSITION',
    JOB_ROLE = 'JOB_ROLE',
}
